import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CheckTransaction  {
    _originalTypeClassName = "zERP.BO.CheckTransaction";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CheckTransaction.translate = translateService;
}
this.Type = new Domain.CheckTransactionType();
this.Check = new Domain.Check();
this.Id = null;
this.CreatedAt = null;
this.Comments = null;
this.MappedWithAccounting = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
CreatedAt:any;
Comments:any;
MappedWithAccounting:any;
Type:any;
Check:any;
static setType = ($this, value) => {
var oldValue = $this.Type;
$this.Type = value;
if (value != null) {
}
}
static setCheck = ($this, value) => {
var oldValue = $this.Check;
$this.Check = value;
if (value != null) {
}
}

static GetClassName(): any{return "CheckTransaction";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}